// Import: Middleware Action & Custom Types
import { CLEAN_MY_SALES_EXECUTIVE, CLEAN_MY_SALES_EXECUTIVE_ERROR } from '_models/redux/types';

// Action function
export const cleanMySalesExecutiveAction = () => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    dispatch({
      type: CLEAN_MY_SALES_EXECUTIVE,
      payload: undefined,
    });
  } catch (e) {
    dispatch({
      type: CLEAN_MY_SALES_EXECUTIVE_ERROR,
      payload: undefined,
    });
  }
};
